import { useState, useRef, useEffect } from 'react';

export function AudioPlayer({ audioUrl, title }) {
  const audioRef              = useRef(null);
  const [playing,  setPlaying]  = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [loading,  setLoading]  = useState(false);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    const onTime     = () => setProgress(audio.currentTime);
    const onDuration = () => setDuration(audio.duration);
    const onEnded    = () => { setPlaying(false); setProgress(0); };
    const onWaiting  = () => setLoading(true);
    const onCanPlay  = () => setLoading(false);
    audio.addEventListener('timeupdate',    onTime);
    audio.addEventListener('loadedmetadata',onDuration);
    audio.addEventListener('ended',         onEnded);
    audio.addEventListener('waiting',       onWaiting);
    audio.addEventListener('canplay',       onCanPlay);
    return () => {
      audio.removeEventListener('timeupdate',    onTime);
      audio.removeEventListener('loadedmetadata',onDuration);
      audio.removeEventListener('ended',         onEnded);
      audio.removeEventListener('waiting',       onWaiting);
      audio.removeEventListener('canplay',       onCanPlay);
    };
  }, []);

  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) { audio.pause(); setPlaying(false); }
    else         { audio.play(); setPlaying(true); }
  };

  const seek = (e) => {
    const audio = audioRef.current;
    if (!audio || !duration) return;
    const rect  = e.currentTarget.getBoundingClientRect();
    const ratio = (e.clientX - rect.left) / rect.width;
    audio.currentTime = ratio * duration;
  };

  const fmt = (s) => {
    if (!s || isNaN(s)) return '0:00';
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${sec.toString().padStart(2,'0')}`;
  };

  if (!audioUrl) return null;

  return (
    <div style={{ display:'flex', alignItems:'center', gap:10,
      padding:'10px 14px', backgroundColor:'rgba(196,165,99,0.06)',
      border:'1px solid rgba(196,165,99,0.2)', borderRadius:8,
      margin:'0 0 16px 0', flexWrap:'wrap' }}>

      <audio ref={audioRef} src={audioUrl} preload="metadata" />

      {/* Play/pause button */}
      <button onClick={togglePlay} style={{
        width:36, height:36, borderRadius:'50%', flexShrink:0,
        backgroundColor: playing ? 'rgba(196,165,99,0.2)' : 'rgba(196,165,99,0.15)',
        border:'1.5px solid rgba(196,165,99,0.5)',
        color:'#c4a563', cursor:'pointer', fontSize:14,
        display:'flex', alignItems:'center', justifyContent:'center',
      }}>
        {loading ? '⏳' : playing ? '⏸' : '▶'}
      </button>

      {/* Label */}
      <div style={{ flexShrink:0 }}>
        <div style={{ color:'#c4a563', fontSize:11, fontWeight:'bold', letterSpacing:'0.4px' }}>
          AUDIO BRIEFING
        </div>
        <div style={{ color:'#555', fontSize:10 }}>
          {fmt(progress)} / {fmt(duration)}
        </div>
      </div>

      {/* Progress bar */}
      <div onClick={seek} style={{ flex:1, minWidth:100, height:4,
        backgroundColor:'rgba(255,255,255,0.08)', borderRadius:2, cursor:'pointer' }}>
        <div style={{ height:'100%', borderRadius:2, backgroundColor:'#c4a563',
          width: duration ? `${(progress/duration)*100}%` : '0%',
          transition:'width 0.1s linear' }} />
      </div>

      {/* Speed control */}
      <select onChange={e => { if (audioRef.current) audioRef.current.playbackRate = parseFloat(e.target.value); }}
        defaultValue="1"
        style={{ background:'transparent', border:'1px solid rgba(196,165,99,0.2)',
          color:'#666', fontSize:10, borderRadius:4, padding:'2px 4px', cursor:'pointer' }}>
        <option value="0.75">0.75×</option>
        <option value="1">1×</option>
        <option value="1.25">1.25×</option>
        <option value="1.5">1.5×</option>
        <option value="2">2×</option>
      </select>
    </div>
  );
}
